import { render, staticRenderFns } from "./LogisticsTrackingDialog.vue?vue&type=template&id=28b68c22&scoped=true"
import script from "./LogisticsTrackingDialog.vue?vue&type=script&lang=js"
export * from "./LogisticsTrackingDialog.vue?vue&type=script&lang=js"
import style0 from "./LogisticsTrackingDialog.vue?vue&type=style&index=0&id=28b68c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b68c22",
  null
  
)

export default component.exports